<template>
  <section class="content">
    <div class="row">
      <div class="col-xs-12 m-b-10" v-if="getRoleType === 99 || getRoleType === 30">
        <router-link :to="{
          name: 'brandMenuTable',
          params: {
            brand_id: $route.params.brand_id
          }
        }">
          <div class="btn btn-default">
            返回菜單建置
          </div>
        </router-link>
      </div>

      <div class="col-md-12">
        <div class="box">
          <!-- box-header -->
          <div class="box-header">
            <div class="font-size-subtitle-2 font-weight-regular">
              <span class="text-red">＊</span>
              <span>白名單：名單內的門市當進行配料庫複製時「可」被覆寫，菜單上架時「可」被複寫</span>
            </div>
            <div class="font-size-subtitle-2 font-weight-regular">
              <span class="text-red">＊</span>
              <span>黑名單：名單內的門市當進行配料庫複製時「不可」被覆寫，菜單上架時「不可」被複寫</span>
            </div>
          </div>
          <!-- End box-header -->

          <div class="box-body">
            <div class="form-inline">
              <div class="row">
                <div class="col-sm-6">
                  <div class="mb-3">
                    <div
                      class="btn btn-default btn-table-title"
                      data-toggle="modal"
                      data-target="#blackModal"
                      v-text="'黑名單設定'"
                    />
                    <router-link :to="{
                      name: 'MenuSettingRuleStoreCopyLogsView'
                    }">
                      <div
                        class="btn btn-default btn-table-title"
                        v-text="'操作歷程'"
                      />
                    </router-link>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table
                    v-if="setting.blacklist"
                    class="table table-bordered table-striped"
                  >
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>設定</th>
                        <th>門市</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="w-xs">1</td>
                        <td class="w-sm">白名單</td>
                        <td class="w-auto" v-text="whitelist" />
                      </tr>
                      <tr>
                        <td class="w-xs">2</td>
                        <td class="w-sm">黑名單</td>
                        <td class="w-auto" v-text="blacklist" />
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>

    <nd-modal
      :option="black.option"
      @trigger="trigger"
    >
      <template v-slot:body>
        <div>
          <div class="mb-2">請選擇要新增或編輯至黑名單的門市，可複選</div>
          <multiselect
            v-model="black.temp"
            tag-placeholder="請輸入或選擇門市"
            placeholder="請輸入或選擇門市"
            label="name"
            track-by="id"
            :options="setting.whitelist"
            :multiple="true"
          />
        </div>
      </template>
    </nd-modal>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'

import NidinModal from '@/components/elements/Modal'

export default {
  name: 'MenuSettingRuleStoreUpdate',
  components: {
    'nd-modal': NidinModal
  },
  data () {
    return {
      black: {
        option: {
          id: 'blackModal',
          title: '黑名單設定',
          btns: [
            {
              name: '取消'
            },
            {
              name: '確定',
              event: 'update'
            }
          ]
        },
        temp: []
      },
      setting: {
        blacklist: [],
        whitelist: []
      }
    }
  },
  methods: {
    getList () {
      const brandId = this.$route.params.brand_id
      const url = `/brand/${brandId}/storeMenuCopySetting`
      this.getDataH('get', url, null, (res) => {
        if (res.data.status === 200) {
          const blacklist = this.handleList(res.data.setting.blacklist)
          const whitelist = this.handleList(res.data.setting.whitelist)
          this.black.temp = blacklist
          this.setting.blacklist = blacklist
          this.setting.whitelist = whitelist
        }
      })
    },
    handleList (list = []) {
      return list.map((i) => {
        let temp = {
          id: i.id,
          name: i.name
        }
        if (!i.name) {
          temp.name = `[${i.id}][無門市名稱]`
        }
        return temp
      })
    },
    trigger (event) {
      if (event === 'update') {
        this.update()
      }
    },
    update () {
      console.log('update')
      const brandId = this.$route.params.brand_id
      const url = `/brand/${brandId}/storeMenuCopySetting`
      this.getDataH('post', url, this.updateInfo, (res) => {
        if (res.data.status === 200) {
          this.$notify({
            title: '設定成功',
            text: '已設定黑名單!',
            duration: 1000,
            type: 'success',
            width: 400
          })
          this.getList()
        }
      })
    }
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    blacklist () {
      const temp = this.setting.blacklist.map((i) => i.name)
      return temp.join('、')
    },
    blackTempId () {
      const temp = this.black.temp.map((i) => i.id)
      return temp
    },
    updateInfo () {
      return {
        blacklist: this.blackTempId
      }
    },
    whitelist () {
      const temp = this.setting.whitelist.map((i) => i.name)
      return temp.join('、')
    }
  }
}
</script>

<style lang="scss" scoped>
.font-size-subtitle-2 {
  font-size: 14px;
}
.font-weight-regular {
  font-weight: 400;
}
.w-xs {
  width: 40px;
}
.w-sm {
  width: 130px;
}
.w-auto {
  width: auto;
}
</style>



// WEBPACK FOOTER //
// MenuSettingRuleStoreCopy.vue?a1d0bca8